import { useEffect, useState } from "react";
import {
  fetchEntityDetails,
  getCachedEntityDetails,
} from "./generalConfig";
import {
  isSubscriptionModuleActive,
  SUBSCRIPTION_APPLICATIONS,
} from "./subscriptionModules";
import { TenantID } from "../Screens/dataSaver";

function buildState(entity, applicationName) {
  return {
    ready: true,
    active: isSubscriptionModuleActive(entity, applicationName),
    entity: entity || null,
  };
}

/**
 * Resolves whether a subscription application is ACTIVE for the current tenant.
 * Uses the shared entity cache when available to avoid layout flash.
 */
export function useSubscriptionModule(applicationName) {
  const [state, setState] = useState(() => {
    const cached = getCachedEntityDetails();
    if (cached) return buildState(cached, applicationName);
    return { ready: false, active: false, entity: null };
  });

  useEffect(() => {
    let cancelled = false;

    const cached = getCachedEntityDetails();
    if (cached) {
      const next = buildState(cached, applicationName);
      setState((prev) =>
        prev.ready === next.ready &&
        prev.active === next.active &&
        prev.entity === next.entity
          ? prev
          : next
      );
    }

    (async () => {
      try {
        const entity = await fetchEntityDetails({ tenantId: TenantID });
        if (!cancelled) setState(buildState(entity, applicationName));
      } catch {
        if (!cancelled) {
          setState({ ready: true, active: false, entity: null });
        }
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [applicationName]);

  return state;
}

export function useSureShieldSubscription() {
  return useSubscriptionModule(SUBSCRIPTION_APPLICATIONS.SURESHIELD);
}
